// Define message types as constants
export const MessageType = {
    SUCCESS: 'success',
    ERROR: 'error',
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType]; // Type for message types
